import { mallTradeApi } from '../request'
import { apiPath } from '../api'

export const shippingFee = {
  getFreightFeeList: data => mallTradeApi.post(apiPath.getFreightFeeList, data),
  getFreightFeeDetail: data =>
    mallTradeApi.post(apiPath.getFreightFeeDetail, data),
  getFreightFeeRules: data =>
    mallTradeApi.post(apiPath.getFreightFeeRules, data),
  getOrderFeeRules: data => mallTradeApi.post(apiPath.getOrderFeeRules, data),
  getOrderFeetabs: data => mallTradeApi.post(apiPath.orderFeetabs, data)
}
